<app-base-modal
  [title]="'Изменение мин/макс лимитов'"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <form
    class="form"
    [formGroup]="changeRrcLimitFormGroup"
  >
    @for (field of changeRrcLimitFormFields; track $index) {
      <app-custom-mat-select
        [label]="field.label"
        [options]="changeRrcLimitSelectData"
        [selectedValueId]="getSelectedValue(field.fieldName)"
        [fullWidth]="true"
        [isEditModeActive]="isEditModeActive"
        (selectedChange)="selectedChange($event, field.fieldName)"
      />
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
